import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mx-auto grid w-full max-w-[1192px] gap-3 md:grid-cols-[auto_auto] md:gap-20',
    title:
      'heading-xl md:heading-xl flex w-full md:max-w-[262px] md:justify-end md:text-right',
    description: 'prose heading-s md:heading-m leading-[1.7]'
  }
});
